import Lottie from 'lottie-web';

export const loadAnimation = (
  data: any,
  element: HTMLElement,
  autoplay = true,
  loop = true,
) => {
  return Lottie.loadAnimation({
    container: element, // the dom element that will contain the animation
    renderer: 'svg',
    loop,
    autoplay,
    animationData: data, // the animation json file
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
      progressiveLoad: true,
      hideOnTransparent: true,
    },
  });
};
